import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function riskSportValidator(control: FormGroup): ValidationErrors | null {
    const canSport = control.value.canSportWithoutRisk;
    const description = control.value.riskDescriptionToSport;

    return (canSport == false) && !description ? { "riskDescriptionToSportMissing": true } : null;
}